import { AutoComplete, Select } from "antd";
import React, { useEffect, useState } from "react";
import { apiCall } from "../utils/Api"
import moment from "moment";

export default function EventSelect(props) {

    const { onChange = () => { }, value = "", disabled = false } = props;


    const [results, setResults] = useState({ rows: [] });

    const fetchEvents = () => {

      

        if (window.sitesettings.using_events_v2) {
            apiCall("event/v2/list", {start_date : moment().format("YYYYMMDD")}, (_status, _result) => {
                if(_status){
                    setResults(_result)
                } else {
                    console.log(_result.error);
                }
            }, "customer")

        } else {
            apiCall("event/getList", { from: moment().format("YYYYMMDD") }, (_status, _result) => {
                if (_status) {
                    setResults(_result)
                } else {
                    console.log(_result.error)
                }
            }, "customer")
        }


    }

    useEffect(fetchEvents, []);



    const getOptions = () => {

        return results.rows.map(item => {

            console.log(item);

            const {
                info = {},
                id = 0,
                from = 0,
                to = 0,
                title = "",
            } = item;

            const {
                name = "",
           
                description = "",
            } = info;

            let _itm = item;
            _itm.label = <small>{(name) ? name : title}</small>;
          
            _itm.value = id;
            return _itm;
        })
    }

    const set = (_id) => {
        onChange(_id);
    }



    return (
        <>
            <Select disabled={disabled} showSearch style={{ "width": "100%", "fontSize": "11px" }} defaultValue={(value) ? value : null} placeholder="Select Event..." onChange={(e) => set(e)} options={getOptions()} />
        </>
    )
}